import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CacheService, MiningToastService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { FilterHandlerService } from 'src/app/modules/core/services/filter/filter-handler.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { LayoutConfigService } from '../../../layout/services/layout-config.service';
import { ReportLoopByOperatorService } from '../../services/report-loop-by-operator.service';
import { LoopByOperatorShellComponent } from '../loop-by-operator-shell/loop-by-operator-shell.component';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';

@Component({
  selector: 'app-loop-by-operator-truck-shell',
  templateUrl: './loop-by-operator-truck-shell.component.html',
  styleUrls: ['./loop-by-operator-truck-shell.component.scss'],
})
export class LoopByOperatorTruckShellComponent extends LoopByOperatorShellComponent implements OnInit {
  constructor(
    protected layoutConfigService: LayoutConfigService,
    protected languageService: LanguageService,
    protected loopOperatorService: ReportLoopByOperatorService,
    protected filterHandlerService: FilterHandlerService,
    public cacheService: CacheService,
    public googleAnalyticsService: GoogleAnalyticsService,
    protected _excelExportService: ExcelExportService,
    protected _toastService: MiningToastService,
    protected cdr: ChangeDetectorRef,
  ) {
    super(
      layoutConfigService,
      languageService,
      loopOperatorService,
      filterHandlerService,
      cacheService,
      googleAnalyticsService,
      _excelExportService,
      _toastService,
      cdr,
    );
  }

  /**
   * On init component
   * Assing layout title, filters, message & machine definition
   */
  public ngOnInit(): void {
    this.isLhd = false;
    this.isTruck = true;
    this.initLayoutTitle();
    this.declareFilters();
    this.cdr.detectChanges();
  }
}
